import { Actions } from "./actions";
import { Heading } from "./heading";
import { PremiumPlan } from "./premium-plan";
import { SubHeading } from "./sub-heading";

export const FinalAppeal = () => {
  return (
    <div
      css={`
        background-color: #f4f4f5;
      `}
    >
      <div
        css={`
          margin: 0 auto;
          max-width: 1218px;
          padding-bottom: 60px;
          display: flex;
          flex-direction: column;

          @media (min-width: 960px) {
            flex-direction: row;
            justify-content: space-between;
            gap: 80px;
            padding: 0 20px;
          }
        `}
      >
        <div
          css={`
            @media (min-width: 960px) {
              flex: 1.1;
              display: flex;
              flex-direction: column;
              justify-content: center;
            }
          `}
        >
          <Heading />
          <SubHeading />
          <Actions />
        </div>

        <div
          css={`
            @media (min-width: 960px) {
              flex: 1;
            }
          `}
        >
          <PremiumPlan />
        </div>
      </div>
    </div>
  );
};
